import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-futbol',
  templateUrl: './futbol.component.html',
  styleUrls: ['./futbol.component.css']
})
export class FutbolComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
